// O UPLOAD DE IMAGEM — pelo BACKEND, e não mais direto para o object storage.
//
// SUBSTITUI `b2.service.ts`, que abria um S3Client no NAVEGADOR com
// `REACT_APP_B2_KEY_ID` e `REACT_APP_B2_APP_KEY`. O `.env.example` do repo já
// dizia o que isso significa: "react-scripts embute REACT_APP_* no bundle —
// quem abrir o app lê". Quem abrisse a Central tinha a chave de escrita do
// bucket `adce-alfredo`. Agora o arquivo vai para `POST /midia`, autenticado, e
// a chave existe só no servidor.
//
// A LEITURA também mudou de lugar: o backend devolve um caminho relativo
// (`/midia/<id>`) e não uma URL do provedor. O motivo é medido — o
// `R2_PUBLIC_URL` que está nos serviços responde 404 para os objetos deste
// bucket. Quem serve a imagem é a nossa própria origem, com cache imutável.
import api from "./api.service";

/** As pastas que o servidor aceita. Espelha `ESCOPOS` do r2.service.ts. */
export type EscopoDeMidia =
  | "perfil"
  | "organizacao"
  | "company"
  | "unidade"
  | "produto"
  | "chat";

export interface MidiaEnviada {
  id: string;
  /** Caminho relativo servido pela nossa origem. */
  url: string;
  bytes: number;
  contentType: string;
}

/**
 * Absoluta, porque o `src` de uma <img> não passa pelo axios: ele sai do
 * navegador direto, e um caminho relativo apontaria para o host do FRONT (o
 * static site), onde a rota não existe.
 */
export function urlAbsolutaDaMidia(url: string): string {
  if (!url) return "";
  if (/^https?:\/\//i.test(url)) return url;
  const base = (api.defaults.baseURL || "").replace(/\/+$/, "");
  return `${base}${url.startsWith("/") ? "" : "/"}${url}`;
}

class MidiaClass {
  /** Sobe o arquivo e devolve a URL pronta para pôr num `src`. */
  async enviar(arquivo: File, escopo: EscopoDeMidia): Promise<string> {
    const corpo = new FormData();
    corpo.append("arquivo", arquivo);
    const resposta = await api.post<MidiaEnviada>(
      `/midia?escopo=${encodeURIComponent(escopo)}`,
      corpo,
      {
        // Deixar o navegador montar o Content-Type: ele precisa incluir o
        // `boundary` do multipart, que o axios não sabe gerar sozinho.
        headers: { "Content-Type": undefined as any },
        timeout: 120000,
      },
    );
    return urlAbsolutaDaMidia(resposta.data.url);
  }

  /**
   * Mantido do b2.service: o recorte de avatar entrega base64, e o upload
   * precisa de File. A conversão não tem nada a ver com storage — por isso
   * sobreviveu à troca.
   */
  base64ParaArquivo(base64: string, nome: string): File {
    const partes = base64.split(",");
    const mime = partes[0].match(/:(.*?);/)?.[1] || "image/jpeg";
    const binario = atob(partes[1]);
    const bytes = new Uint8Array(binario.length);
    for (let i = 0; i < binario.length; i += 1) bytes[i] = binario.charCodeAt(i);
    return new File([bytes], nome, { type: mime });
  }
}

export const midiaService = new MidiaClass();
export default midiaService;
